<template>
  <div class="courseDjustment">
    <courseDjustmentTopbar
      v-model="currentCourseIndex"
      :statusList="statusList"
      @currentContentIndex="currentContentIndex"
      @searchText="searchText"
      @searchVenueName="searchVenueName"
      @addCourseAdjustment="addCourseAdjustment"
    />
    <div class="courseDjustment-main">
      <courseDjustmentContentItem
        v-for="(item, index) in statusList"
        :key="index"
        :isCurrentContentItem="currentCourseIndex == index"
        :currentStatus="statusList[currentCourseIndex].value"
        @updateStatus="updateStatus"
        :changeStatus="changeStatus"
        :searchContent="searchContent"
        :searchVenueNameContent="searchVenueNameContent"
        ref="courseContentItem"
      />
    </div>
    <!-- 申请调课弹窗 -->
    <addCourseAdjustmentDialog
      :addDialogShow.sync="addDialogShow"
      v-if="addDialogShow"
      :dictTypeList="dictTypeList"
      @addTeacherApplyFor="getCourseDjustmentList"
      :className="className"
      :classPlaceholder="classPlaceholder"
      :classProps="classProps"
      :classSelect="classSelect"
      :classData="classData"
    />
  </div>
</template>
  
  <script>
import courseDjustmentTopbar from "./components/courseDjustment-topbar/courseDjustment-topbar.vue";
import courseDjustmentContentItem from "./components/courseDjustment-content-item/courseDjustment-content-item.vue";
import addCourseAdjustmentDialog from "./components/courseAdjustment-add/courseAdjustmentAdd.vue";

export default {
  data() {
    return {
      addDialogShow: false,
      currentCourseIndex: 0,
      changeStatus: 0,
      searchVenueNameContent: "",
      searchContent: "",
      statusList: [
        {
          label: "待审批",
          value: 0,
        },
        {
          label: "审批通过",
          value: 1,
        },
        {
          label: "审批拒绝",
          value: 2,
        },
        {
          label: "已撤回",
          value: 3,
        },
      ],
      courseDjustmentDetail: {},
      detailShow: false,
      dictTypeList: [],
      // 处理后的班级年级多选数据
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      // 选中后的班级年级
      className: [],
      // 班级年级数据
      classSelectList: [],
      classPlaceholder: "",
      classData: {
        classId: "",
        className: "",
      },
    };
  },
  components: {
    courseDjustmentTopbar,
    courseDjustmentContentItem,
    addCourseAdjustmentDialog,
  },
  created() {
    this.getDictType();
    this.getTeacherBindGradeClass();
  },
  methods: {
    getTeacherBindGradeClass() {
      this.get(this.$url.getTeacherBindGradeClass).then((res) => {
        this.classSelectList = res.data;
        this.classSelectListLength = this.classSelectList.length;
        // console.log(this.classSelectList.length);
        if (this.classSelectList.length) {
          this.classSelectList.forEach((gItem, g) => {
            let { gradeCode, gradeId, gradeName } = gItem;
            gItem.value = {
              gradeCode,
              gradeId,
              gradeName,
            };
            gItem.label = gItem.gradeName;
            gItem.schoolClassList.forEach((cItem, c) => {
              let { classCode, classId, className } = cItem;
              cItem.value = {
                classCode,
                classId,
                className,
              };
              cItem.label = cItem.className;
            });
          });
          this.classSelect = this.classSelectList;
          // 默认选中时的classId/className
          this.classData.classId =
            this.classSelect[0].schoolClassList[0].classId;
          this.classData.className =
            this.classSelect[0].schoolClassList[0].className;

          // 默认选中第一个年级班级
          let firstGrade = {};
          let { gradeCode, gradeId, gradeName } = this.classSelect[0];
          firstGrade = { gradeCode, gradeId, gradeName };
          let firstClass = {};
          let { classCode, classId, className } =
            this.classSelect[0].schoolClassList[0];
          firstClass = { classCode, classId, className };
          this.className = [firstGrade, firstClass];
          this.classPlaceholder = `${firstGrade.gradeName} / ${firstClass.className}`;
          // console.log("处理后的数据==>", this.classSelect);
        }
      });
    },
    // 调课原因字典
    getDictType() {
      this.get(this.$url.getDictType + "/teacher_leave_type").then((res) => {
        // console.log("数据字典调课原因==>", res);
        this.dictTypeList = res.data;
      });
    },
    getCourseDjustmentList() {
      const randomFloat = Math.random();
      this.changeStatus = randomFloat;
    },
    addCourseAdjustment(e) {
      this.addDialogShow = e;
    },
    // 搜索词(接受topbar传来的值)
    searchText(e) {
      // 搜索词改变时才赋值
      if (this.searchContent != e) {
        this.searchContent = e;
      }
    },
    searchVenueName(e) {
      // 搜索词改变时才赋值
      if (this.searchVenueNameContent != e) {
        this.searchVenueNameContent = e;
      }
    },
    updateStatus(e) {
      // console.log("updateStatus", e);
      this.changeStatus = e;
    },
    // 当前选中状态下标
    currentContentIndex(e) {
      this.currentCourseIndex = e;
    },
  },
};
</script>
  
  <style scoped lang="scss">
@import "./courseDjustment.scss";
</style>